/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeviceIntegrationProvider,
  DeviceIntegrationProvider$inboundSchema,
} from "./deviceintegrationprovider.js";

export type ListDeviceIntegrationProvidersResult = {
  /**
   * Every available provider, sorted by id.
   */
  providers: Array<DeviceIntegrationProvider>;
};

/** @internal */
export const ListDeviceIntegrationProvidersResult$inboundSchema: z.ZodMiniType<
  ListDeviceIntegrationProvidersResult,
  unknown
> = z.object({
  providers: z.array(DeviceIntegrationProvider$inboundSchema),
});

export function listDeviceIntegrationProvidersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDeviceIntegrationProvidersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListDeviceIntegrationProvidersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDeviceIntegrationProvidersResult' from JSON`,
  );
}
